import React, { Component } from "react";
import { Link } from "react-router";

import CollapseImage from "../containers/assets/icon_collapse.svg";
import { detectMobile } from "../services/utils";

import HelpIconButtonWithTooltipAndTypeformModal from "../components/typeform/HelpIconButtonWithTooltipAndTypeformModal";
import TabNavigation from "../components/results/TabNavigation";
import TypeformContent from "../components/typeform/TypeformContent";

class FNAnalysisIncomeState extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentUrl: "IncomeStatement",
      currentBaseUrl: "ceo",
      roundInUrl: props.roundInUrl
    };

    this.isMobile = detectMobile();
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.roundInUrl !== nextProps.roundInUrl) {
      this.setState(
        {
          roundInUrl: nextProps.roundInUrl
        },
        () => {
          this.detectCurrentLocation();
        }
      );
    }
  }

  detectCurrentLocation() {
    let parts = this.props.location.pathname.split("/");
    let currentUrl = "IncomeStatement";
    let currentBaseUrl = "ceo";

    if (parts.length === 5 && parts[4].length > 0) {
      currentUrl = parts[4];
    }

    if (parts.length >= 2) {
      currentBaseUrl = parts[1];
    }

    if (currentUrl !== this.state.currentUrl) {
      this.setState({
        currentUrl
      });
    }

    if (currentBaseUrl !== this.state.currentBaseUrl) {
      this.setState({
        currentBaseUrl
      });
    }
  }

  componentDidMount() {
    this.detectCurrentLocation();
  }

  componentDidUpdate() {
    this.detectCurrentLocation();
  }

  updateSidebar = currentUrl =>
    this.setState({
      currentUrl
    });

  render() {
    const { currentUrl, currentBaseUrl, roundInUrl } = this.state;
    const { currentRound, rounds } = this.props;
    const rowStyle = this.isMobile
      ? {
          marginLeft: 0,
          marginRight: 0
        }
      : {};
    const colClass = this.isMobile ? "col-xs-12 no-padding" : "col-xs-12";

    return (
      <section className="analysis section-mobile bg-gray">
        <div className="row" style={rowStyle}>
          <div className={colClass}>
            <div className="container-analysis report-collapse none-shadow">
              <TabNavigation
                updateSidebar={this.updateSidebar}
                currentUrl={currentUrl}
                currentBaseUrl={currentBaseUrl}
                roundInUrl={roundInUrl}
                currentRound={currentRound}
                isMobile={this.isMobile}
              />
              <h3 className="semibold">
                Financials
                <HelpIconButtonWithTooltipAndTypeformModal
                  {...TypeformContent.FINANCIALS}
                />
                <Link to="/fn/results" className="icon-zoom">
                  <img
                    src={CollapseImage}
                    className="icon"
                    alt="CollapseImage"
                  />
                </Link>
              </h3>
              <div className="bg-white p-20 mt-20">
                {React.Children.map(this.props.children, child =>
                  React.cloneElement(child, {
                    rounds,
                    currentRound,
                    roundInUrl
                  })
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default FNAnalysisIncomeState;



// WEBPACK FOOTER //
// ./src/containers/FNAnalysisFNStatements.js